import React, { FC } from 'react';
type FormTabSwitcherPropsType<T> = {
  valuesList: Array<{ value: string; title: string; disabled?: boolean }>;
  isActive: string;
  onChange(value: T): void;
  disabled?: boolean;
  classname?: string;
};
const FormTabSwitcher: FC<FormTabSwitcherPropsType<string>> = (props) => {
  const { valuesList, isActive, onChange, disabled, classname } = props;
  return (
    <div
      className={`${
        classname ?? classname
      } w-full flex items-center justify-around bg-basic_app_bg shadow-xl rounded-[10px] p-[3px] shadow-md`}
    >
      {valuesList.map((currentValue) => (
        <div
          onClick={() => !disabled && onChange(currentValue.value)}
          className={`${
            isActive === currentValue.value && 'bg-white'
          } py-[8px] transition-all duration-300 ${
            !disabled ? 'hover:bg-white' : '!cursor-not-allowed'
          } w-full text-[14px] text-center cursor-pointer  rounded-[10px]`}
          key={currentValue.value}
        >
          {currentValue.title}
        </div>
      ))}
    </div>
  );
};

export default FormTabSwitcher;
